import { fetchData } from './methods';

export default function downloadFile(uri,
	startingDownloading = () => {},
	finishedDownloading = () => {}) {
	startingDownloading();
	fetchData({
		uri,
		accept: '*/*',
	})
		.then(({
			ok,
			body,
			disposition,
		}) => {
			if (ok) {
				const filename = /filename="(.+)"/.exec(disposition)[1];
				const href = window.URL.createObjectURL(body);
				const link = document.createElement('a');
				link.href = href;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(href);
			}
			finishedDownloading();
		});
}
